import {
  buildPath,
  buildTemplatePath,
  ListContext,
  ListContextValue,
  Page,
  PageRoute,
  pn,
  Stack,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import {
  Contributor,
  ContributorEmployment as ContributorEmploymentModel,
  ContributorViewResource,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { ContributorBasicInfo } from "../ContributorPage/ContributorBasicInfo";
import { ContributorEmployment } from "./ContributorEmployment";
import { ContributorPageHeader } from "./ContributorPageHeader";

const routeName = "createContributor";

export const contributorCreatePageRoute: PageRoute = {
  handle: "New Contributor",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const ContributorCreatePage = () => {
  const [contributor, setContributor] = useState<Contributor>({} as Contributor);
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [contributor] });
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const [viewResource, setViewResource] = useState<ContributorViewResource>({});
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(0);
    fetchViewResource(0);
  }, []);

  const fetch = (id: number) => {
    ApiService.contributors.get(id).then((response) => {
      setContributor(response);
      resetUnsavedChanges([response]);
    });
  };

  const fetchViewResource = (id: number) => {
    ApiService.contributors.getViewResource(id).then((response) => {
      setViewResource(response);
    });
  };

  return (
    <Page
      isForm
      header={
        <ContributorPageHeader
          handle={contributorCreatePageRoute.handle}
          contributor={contributor}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
        />
      }
    >
      <Stack spacing="lg">
        <ContributorBasicInfo
          contributor={contributor}
          setContributor={setContributor}
          viewResource={viewResource}
          crudMode={"edit"}
          validationErrors={validationErrors}
        />

        <ContributorEmployment
          employment={contributor?.creatingFirstEmployment || ({} as ContributorEmploymentModel)}
          setEmployment={(employment) =>
            setContributor(
              produce((draft) => {
                draft.creatingFirstEmployment = employment;
              })
            )
          }
          validationErrors={validationErrors[pn<Contributor>("creatingFirstEmployment")] || {}}
        />
      </Stack>
    </Page>
  );
};
